import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="panel-navy mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div>
            <div className="mb-4">
              <Logo/>
              <div className="text-[10px] uppercase tracking-[0.25em] text-white/60 mt-3">Wokingham · UK</div>
            </div>
            <p className="text-white/70 text-sm leading-relaxed">
              Premium GCSE Maths tuition. 20,000+ question bank. Tutors who care.
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] brand-gold mb-4">Programme</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/gcse">GCSE Maths</Link></li>
              <li><Link to="/gcse">Year 7–11</Link></li>
              <li><Link to="/gcse">Foundation & Higher</Link></li>
              <li><Link to="/gcse">Mock Exam Prep</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] brand-gold mb-4">Company</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/about">Our Approach</Link></li>
              <li><Link to="/blog">Insights</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><Link to="/signup">Book free trial</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] brand-gold mb-4">Contact</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li>hello@geniuseducation.co.uk</li>
              <li>Wokingham, Berkshire</li>
              <li className="pt-3">Mon–Sat · 9am–8pm</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/50">
          <p>© {new Date().getFullYear()} Genius Education. All rights reserved.</p>
          <p>Crafted for the pursuit of academic excellence.</p>
        </div>
      </div>
    </footer>
  );
}
